<template>
    <div class="content">
        <section>
            <div class="content-box">
                <HeaderBg :title="'Schedule'" :sub_title="'LOTTERY'" :desc="''" />

                <div class="text-center">
                    <h2 class="fw-bold mt-5">3D QUICK PICK</h2>
                    <p class="text-muted" style="font-size: 14px;">Results every 45 minutes (32x results a day)</p>


                    <div class="text-center p-5"
                        style="background: url('assets/bg_schedule.png');background-repeat:  no-repeat;background-size: 100% 100%">
                        <h2 class="text-white">4D Result</h2>
                        <p class="text-muted" style="font-size: 14px; color: white !important;">Result Every 8 Hours (3x Result a day)</p>
                        <p class="text-white m-0 p-0 pt-3" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #FFCD05;">Third Prize Draw</span>
                            <span style="font-style: italic;"> starts at 12:00 Wib</span>
                        </p>
                        <p class="text-white m-0 p-0" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #FFCD05;">Second Prize Draw</span>
                            <span style="font-style: italic;"> starts at 20:00 Wib</span>
                        </p>
                        <p class="text-white m-0 p-0" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #FFCD05;">First PrizeDraw</span>
                            <span style="font-style: italic;"> starts at 04:00 Wib</span>
                        </p>
                    </div>

                    <div class="text-center p-3">
                        <h2 class="text-dark">5D Result</h2>
                        <p class="text-muted" style="font-size: 14px;">Result Everyday (1x Result a day)</p>
                        <p class="text-dark m-0 p-0 pt-3" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #223B89;">Third Prize Draw</span>
                            <span style="font-style: italic;"> starts at 12:00 Wib</span>
                        </p>
                        <p class="text-dark m-0 p-0" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #223B89;">Second Prize Draw</span>
                            <span style="font-style: italic;"> starts at 12:00 Wib</span>
                        </p>
                        <p class="text-dark m-0 p-0" style="font-size: 15px;">- <span class="fw-bold"
                                style="color: #223B89;">First PrizeDraw</span>
                            <span style="font-style: italic;"> starts at 12:00 Wib</span>
                        </p>
                    </div>

                    <div>
                        <img src="/assets/schedule_image.png" class="img-fluid" style="width: 100%" />
                    </div>


                </div>

            </div>
        </section>
    </div>
</template>

<script>
import HeaderBg from './components/HeaderBg.vue';

export default {
    name: 'SchedulePage',
    components: {
        HeaderBg
    }
}
</script>

<style scoped></style>
